import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

export class CustomMatPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();
  itemsPerPageLabel = 'Einträge/Seite';
  nextPageLabel = 'Nächste Seite';
  previousPageLabel = 'Vorherige Seite';
  firstPageLabel = 'Erste Seite';
  lastPageLabel = 'Letzte Seite';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `1 von 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `${page + 1} von ${amountPages}`;
  }
}
